import type { QuizSteps } from "@/types/api.types";
import Loader from "@/components/atoms/Loader";
import QuizTitle from "@/components/atoms/QuizTitle";

const AnalysisLoaderStep = ({ step, onAnswer }: QuizSteps) => {
  if (step.type !== "analysis_loader") return null;

  const handleComplete = () => {
    onAnswer("done");
  };

  return (
    <div>
      <QuizTitle title={step.title} />

      <div className="mt-14 flex min-h-[248px] flex-col items-center justify-center text-center">
        <Loader
          duration={step.duration || 3}
          color="#59AFFF"
          subtitle={step.subtitle}
          onComplete={handleComplete}
        />
      </div>
    </div>
  );
};

export default AnalysisLoaderStep;
